<gs-generic-crud [advancedSearch]="true" *ngIf="config" [configuration]="config" canCreate="false" canEdit="false"></gs-generic-crud>
